import TranslationText from '@Components/Utilities/TranslationText';
import ValueInsightPortalBanner from '@Components/Shared/ValueInsightPortalBanner';
import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const HighLowAverageMobile = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);

    return (
        <div id='high-low-average-mobile-content'>
            <section id='high-low-average-top'>
                <div>
                    <ComplexBreadcrumb BreadCrumbModels={props.Breadcrumbs} />
                    <h1 id='high-low-title'><TranslationText tKey='sandhills.tradepubwebsite.mvc.hilowaverage' /></h1>
                    {!currentSite.IsMobileAppContext &&
                        <div>
                            <a href={props.AllListingsPageURL} id='return-to-listings-link'>
                                <i className='fas fa-arrow-left' />&nbsp;
                                <TranslationText tKey='sandhills.returntolistings' />
                            </a>
                        </div>
                    }
                    {props.RegionFilterURL &&
                        <div id='region-filter'>
                            <a href={props.RegionFilterURL}>{props.RegionFilterLinkText}</a>
                        </div>
                    }
                </div>
            </section>
            <div id='high-low-average-main-content'>
                <section id='search-criteria'>
                    {(props.Criteria && Object.keys(props.Criteria).length > 0) && Object.keys(props.Criteria).map(key =>
                        <div key={key} className='criteria'>
                            <b>{key}:</b>&nbsp;{props.Criteria[key]}
                        </div>)}
                </section>
                {!props.ShowAV &&
                    <ValueInsightPortalBanner />
                }
                <table id='high-low-average-table'>
                    <colgroup>
                        <col />
                        <col />
                        <col />
                    </colgroup>
                    <thead>
                        <tr>
                            <td id='description-column'></td>
                            <th>{props.RetailTitle}</th>
                            {props.ShowAuctionHighLowAverage &&
                                <th><TranslationText tKey='sandhills.tradepubwebsite.mvc.auction' /></th>}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><TranslationText tKey='sandhills.tradepubwebsite.mvc.totalnumberoflistingsfound' /></td>
                            <td><a href={props.ListingPageURL}>{props.Retail.Count}</a></td>
                            {props.ShowAuctionHighLowAverage &&
                                <td><a href={props.AuctionPageURL}>{props.Auction.Count}</a></td>}
                        </tr>
                        <tr>
                            <td><TranslationText tKey='sandhills.tradepubwebsite.mvc.highestpricefound' /></td>
                            <td>{props.Retail.MaximumPrice}</td>
                            {props.ShowAuctionHighLowAverage &&
                                <td>{props.Auction.MaximumPrice}</td>}
                        </tr>
                        <tr>
                            <td><TranslationText tKey='sandhills.tradepubwebsite.mvc.lowestpricefound' /></td>
                            <td>{props.Retail.MinimumPrice}</td>
                            {props.ShowAuctionHighLowAverage &&
                                <td>{props.Auction.MinimumPrice}</td>}
                        </tr>
                        <tr className='bold'>
                            <td><TranslationText tKey='sandhills.tradepubwebsite.mvc.averageprice' /></td>
                            <td>{props.Retail.AveragePrice}</td>
                            {props.ShowAuctionHighLowAverage &&
                                    <td>{props.Auction.AveragePrice}</td>}
                        </tr>
                        <tr className='bold'>
                            <td><TranslationText tKey='sandhills.avgwohighlow' /></td>
                            <td>{props.Retail.AdjustedAveragePrice}</td>
                            {props.ShowAuctionHighLowAverage &&
                                    <td>{props.Auction.AdjustedAveragePrice}</td>}
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                <section id='bottom-description' dangerouslySetInnerHTML={{ __html: props.Explanation }} />
            </div>
        </div>
    );
};

export default HighLowAverageMobile;